import { api } from "../api";
import { EventResponse } from "../../../types/types";

/**
 * findEventByCustomerAndDate - Function that finds on database the last event accurred by customer  
 * /events/{customerId}/last    
 * method GET 
 * @async-function
 */
const findEventByCustomerAndDate = async (token: string, customerId: number) => {
    const response = await api.get<EventResponse | null>(
        `/events/${customerId}/last`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};
export default findEventByCustomerAndDate;
